import { For, Show, createEffect, onCleanup, onMount } from "solid-js";
// import { useHeroForm } from "../contexts/HeroFormContext"

// import { HorizontalScroller } from "../../ts/theme.ts";
import { HorizontalScrollerGradient } from "../components/HorizontalScroller";
import { twMerge } from "tailwind-merge";

const ColorPill = (props) => {
  return (
    <li
      ref={props.ref}
      id={`swatch-${props.id}`}
      class={`horizontal-scroller-slide first:ml-2 last:mr-2 lg:first:ml-6 lg:last:mr-6 ${props?.isModal ? '' : ''}`}
      data-spv={props.salesPerView}
      classList={{
        'active': props.isSelected
      }}
      onclick={() => {
        window.posthog?.capture('color_switched', {
          experiment_flags: window.experimentFlags,
          product: window.location.pathname.replace('/products/', '')?.split('-')?.join(' '),
          color: props.id?.split('-')?.join(' ')
        })
        props.colorSelectionHandler(props.id)
      }}>
      {/* <span class="swatch" style="width:48px; height:64px;"> */}
      <span class="swatch">
        <div class="relative">
          <img src={`${props.src}&width=16`}
            data-srcset={props.srcSet}
            class={`lazyload ${props?.isModal ? '!h-7 !w-6' : ''} ${(props.isOutOfStock && !props.isSelected) ? 'opacity-60' : ''}`}
            width="auto"
            height="auto" data-sizes="auto" alt={props.label} loading="lazy" />
          <Show when={props.isOutOfStock}>
            <div class={`absolute w-full h-full top-0 left-0 right-0 bottom-0 overflow-x-hidden rounded-lg ${props.isSelected ? 'text-ink' : 'text-canvas'}`}>
              <svg class="w-full h-full" fill="none" viewBox="0 0 64 80">
                <line y1="0" stroke="currentColor" stroke-width="2" y2="80" x2="0" x1="64"></line>
              </svg>

            </div>
          </Show>
        </div>
      </span>
      <span class="color-name text-secondary-800">{props.label}</span>
    </li>
  )
}

const ColorPillSmall = (props) => {
  console.log("inside ColorPill in ColorOptionsContainer")

  return (
    <li
      ref={props.ref}
      id={`swatch-${props.id}`}
      class={twMerge(
        `horizontal-scroller-slide ${props?.isModal ? '' : ''}`,
        props.class ?? ""
      )}
      data-spv={props.salesPerView}
      classList={{
        'active !border-ink-light': props.isSelected
      }}
      onclick={() => {
        window.posthog?.capture('color_switched', {
          experiment_flags: window.experimentFlags,
          product: window.location.pathname.replace('/products/', '')?.split('-')?.join(' '),
          color: props.id?.split('-')?.join(' ')
        })
        props.colorSelectionHandler(props.id)
      }}>
      {/* <span class="swatch" style="width:48px; height:64px;"> */}
      <span class="">
        <div class="relative w-4 h-4">
          <img src={`${props.src}&width=16${props?.isModal ? '' : '&height=16&crop=center'}`}
            data-srcset={props?.isModal ? props.srcSet : props.squareSrcSet}
            class={`rounded-lg w-full h-full lazyload ${props?.isModal ? '!h-7 !w-6' : ''} ${(props.isOutOfStock && !props.isSelected) ? 'opacity-60' : ''}`}
            width="auto"
            height="auto" data-sizes="auto" alt={props.label} loading="lazy" />
          <Show when={props.isOutOfStock}>
            <div class={`absolute w-full h-full top-0 left-0 right-0 bottom-0 overflow-x-hidden rounded-lg ${props.isSelected ? 'text-ink' : 'text-canvas'}`}>
              <svg class="w-full h-full" fill="none" viewBox="0 0 32 32">
                <line y1="0" stroke="currentColor" stroke-width="2" y2="32" x2="0" x1="32"></line>
              </svg>
            </div>
          </Show>
        </div>
      </span>
      <span class="color-name text-secondary-800">{props.label}</span>
    </li>
  )
}

const AlsoAvailablePill = (props) => {
  const { experimentFlagsSignal,
    getters: {
      getExperimentFlags
    } } = props.context();

  return <li
    style={`display:none`}
    class={`${props.index === 0 ? 'ml-2' : ''} horizontal-scroller-slide flex-shrink-0 last:mr-2 lg:last:mr-6 hidden sm:hover:bg-none transition-transform hover:scale-[97.7%] rounded-xl overflow-hidden cursor-pointer`}>
    <a href={`${window.location.protocol + "//" + window.location.host}/products/${props.handle}`}
      title={props.fabricType}
      class={`  flex flex-col relative normal-case items-stretch flex-shrink-0 justify-center  h-10`}
    >
      <div class="bg-canvas-depressed text-ink-light z-20 text-2xs uppercase font-mono text-center pt-0.5 w-full whitespace-nowrap min-w-max px-2">Also available in</div>
      <div class="bg-canvas-depressed text-ink-light z-10 text-xs font-regular text-center   whitespace-nowrap w-full pb-0.5 px-2">{props.fabricType}</div>
      <div class="absolute top-0 left-0 size-full flex justify-evenly overflow-hidden divide-canvas divide-x-inner">
        <Index each={Object.values(props.swatchImgUrl).slice(0, 3)}>
          {(swatchUrl, index) => <div class="flex-1"><img style="border-radius:0px"
            class={`h-10 object-cover object-center basis-auto contrast-75 opacity-85 w-full`}
            src={`${swatchUrl()}&width=80`} alt={props.colors[index]} />
          </div>
          }
        </Index>
      </div>
    </a>
  </li>
}

export const ColorOptionsContainer = (props) => {

  const {
    color: {
      color,
      handlers: {
        handleColorSelection
      }
    },
    getters: {
      getExperimentFlags
    },
    handlers: {
      handleColorChange
    },
    heroSectionSettings
  } = props.context();

  const colorOptions = () => Object.values(color().options);
  const selectedColor = () => color().selected;
  const centerColorPill = (colorId) => {
    const elem = document.getElementById(`swatch-${colorId}`);
    const parentElem = elem.parentElement;

    const rect = elem.getBoundingClientRect();
    const parentRect = parentElem.getBoundingClientRect();

    const scrollLeft = rect.left - parentRect.left + parentElem.scrollLeft;
    const scrollCenter = scrollLeft - parentElem.clientWidth / 2 + rect.width / 2;

    // elem.scrollIntoView({
    //   behavior: "smooth",
    //   block: "nearest",
    //   inline: "nearest"
    // })

    parentElem.scrollTo({
      left: scrollCenter,
      behavior: 'smooth'
    })
  }

  const colorSelectionHandler = (colorOptionId) => {
    handleColorSelection(colorOptionId);
    handleColorChange({ color: colorOptionId })

    centerColorPill(colorOptionId);
  }

  onMount(() => {
    centerColorPill(selectedColor());
  })

  const colorPills = () => {
    const colorPillsArr = colorOptions().sort((a, b) => { return a.salesPerView - b.salesPerView }).reverse().map((colorOption) => {
      const isSelected = () => colorOption.id == selectedColor();
      const isOutOfStock = () => colorOption.isOutOfStock
      const src = colorOption.swatchImages.src;
      // The inline swatch is a 16×16 box, so crop the fabric photo square server-side (natural and
      // displayed aspect then match). The modal swatch is 6×7 and keeps the uncropped image.
      const srcSet = [34, 49, 58, 68, 102, 116, 174].map(width => `${src}&width=${width} ${width}w`).join(', ')
      const squareSrcSet = [34, 49, 58, 68, 102, 116, 174].map(width => `${src}&width=${width}&height=${width}&crop=center ${width}w`).join(', ')

      return {
        component: heroSectionSettings.isNewVersion ? ColorPillSmall : ColorPill,
        props: {
          id: colorOption.id,
          isSelected: isSelected(),
          label: colorOption.label,
          src: src,
          srcSet: srcSet,
          squareSrcSet: squareSrcSet,
          isOutOfStock: isOutOfStock(),
          class: props.colorClass ?? '',
          salesPerView: colorOption.salesPerView,
          colorSelectionHandler: colorSelectionHandler,
          isModal: props?.isModal
        }
      }
    });

    if (typeof showRelatedProducts != "undefined") {
      if (showRelatedProducts) {

        Object.values(relatedProducts).forEach((relatedProduct, index) => {
          relatedProduct['index'] = index
          colorPillsArr.push({
            component: AlsoAvailablePill,
            props: {
              ...relatedProduct,
              context: props.context
            }
          })
        })
      }
    }

    return colorPillsArr;
  }

  return (
    <div id="phcf-current-product-colors"
      class={twMerge(
        `flex flex-col scroll-mt-9 justify-center items-start font-bold uppercase border-t-outer w-full py-1 ${props?.isModal ? 'py-0.5' : 'border-frame sm:landscape:border-t-outer sm:py-4'}  sm:landscape:items-center`,
        props.class ?? ''
      )}
      classList={{
        // "mt-1 gap-1": props.isModal == true
      }}>


      <span
        class={twMerge(
          "font-regular flex items-baseline justify-start gap-1 normal-case w-full sm:text-left px-2 sm:landscape:px-6 sm:landscape:pb-0 text-xs sm:text-sm",
          props.labelClass ?? ""
        )}

      >
        <div>
          <span class="font-bold">Color: </span>
          <span class="font-normal">{color().options[selectedColor()].label}</span>
        </div>
        <Show when={color().options[selectedColor()].isOutOfStock == true}>
          <div class="text-xs sm:text-base  text-secondary-accent uppercase font-monobold">[Sold Out]</div>
        </Show>
      </span>

      <HorizontalScrollerGradient
        wrapper="ul"
        wrapperClass={twMerge(
          `horizontal-scroller-wrapper scrollbar-hide product-hero-swatches ${props.isModal != true ? "pt-1" : ''} pb-0.5  sm:landscape:p-0 max-w-full`,
          heroSectionSettings.isNewVersion ? '!flex-wrap !overflow-visible px-2 sm:landscape:px-6 sm:landscape:pb-0 text-xs sm:text-sm sm:px-6' : '',
          props.wrapperClass ?? ""
        )}
        parentClass=""
        slides={colorPills()}
        scrollMultiplier={0.5}
        hideArrows={heroSectionSettings.isNewVersion}
      />

    </div>
  )
}